import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import pkg from "../../package.json";

/**
 * Tiny footer badge showing app version + build channel. Rendered in the
 * driver menu so the office can eyeball which build a driver is running
 * when they call to say "hey it's broken".
 *
 * Version lives in package.json (bump before every deploy). Build
 * channel is derived from ``NODE_ENV`` + Capacitor runtime detection.
 * ``REACT_APP_BUILD_ID`` is optional — set it in CI to show a commit
 * short-hash / build timestamp.
 */
export function AppVersionBadge({ className = "" }) {
    const [platform, setPlatform] = useState("web");
    useEffect(() => {
        setPlatform(Capacitor.getPlatform());
    }, []);

    const buildId = process.env.REACT_APP_BUILD_ID;
    const channel = process.env.NODE_ENV === "production" ? "prod" : "dev";
    const label = platform === "web" ? "PWA" : platform.toUpperCase();

    return (
        <div
            className={`text-[10px] font-mono text-muted-foreground/70 tracking-wide select-text ${className}`}
            data-testid="app-version-badge"
            title="Bug? Send this to the office."
        >
            v{pkg.version} · {label} · {channel}
            {buildId ? ` · ${buildId.substring(0, 7)}` : ""}
        </div>
    );
}
